export default {"src":"/_next/static/media/share_filled.c22cf53f.svg","height":24,"width":24};